






















































































































































































































































































































import { Component } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import { mapGetters, mapState } from 'vuex'
import CardModel from '@/_models/CardModel'

// DumpsComponent
import BeaconCamera from '../shared/BeaconCamera.vue'

import CardAdjust from '@/components/card/partials/CardAdjust.vue'
// Common
import NotFound from '@/components/common/NotFound.vue'
// Shared
import SearchFloor from '@/components/shared/SearchFloor.vue'
import SearchSanID from '@/components/shared/SearchSanID.vue'
import FilterDropdown from '@/components/shared/FilterDropdown.vue'
import TablePagination from '@/components/shared/TablePagination.vue'

import TableSortMixin from '@/components/mixins/TableSortMixin.vue'

import * as DownloadCsv from 'vue-json-csv'
import { Constant } from '@/_services/constant'
import { Filter } from '@/_utils/filter'

@Component({
  components: {
    SearchFloor,
    SearchSanID,
    CardAdjust,
    DownloadCsv,
    FilterDropdown,
    NotFound,
    TablePagination,
    BeaconCamera,
  },
  computed: {
    ...mapGetters('cards', {
      canEdit: 'canEdit',
    }),
    ...mapGetters('cards', {
      canDelete: 'canDelete',
    }),
  },
})
export default class CardList extends mixins(TableSortMixin) {
  canEdit!: () => boolean
  canDelete!: () => boolean

  // data
  filterUtilTableSort: any = new Filter('filter_card_list_table_sort')
  filterUtilPage: any = new Filter('filter_cardlist_page')
  pageFilters: any = {
    currentPage: 1,
    perPage: 10,
    selectedFilter: 'san_id',
    searchQuery: '',
    activeTab: 0,
  }

  numofPage: number = 1
  selected: any = {}
  isFormModalActive: boolean = false
  isImportCsvModalActive: boolean = false
  isCardAdjustActive: boolean = false
  isSingleAdjustCard: boolean = false
  isSearchFloorActive: boolean = false
  isSearchSanIDActive: boolean = false

  activeTabEdit: number = 0

  filedNameLUT: any = {
    _id: 'UUID',
    san_id: 'label.san_id',
    location_name: 'label.possition',
    lon: 'label.lon',
    lat: 'label.lat',
    floor_name: 'label.floor',
    floor_id: 'label.floor_id',
  }

  // Import/Export csv setting
  csvFile: any = null
  csvFields: any = []

  // computed
  get manageFeature() {
    return this.authen?.currentUser?.manage_features
  }
  get authen() {
    return this.$store.state.authentication
  }

  get cards(): CardModel[] {
    const cards = this.$store.state.cards.all.items
    this.numofPage = Math.ceil(cards.length / this.pageFilters.perPage)

    return cards
  }

  get buttonSaveText(): any {
    return this.isNew ? this.$t('button.register') : this.$t('button.save')
  }

  get isNew(): boolean {
    return !this.selected._id
  }

  get isLoading(): boolean {
    return this.$store.state.cards.loading
  }

  get filteredData(): CardModel[] {
    const targetField: string = this.pageFilters.selectedFilter
    if (!this.cards) {
      return []
    }

    return this.cards.filter((item: any): boolean => {
      const searchKey =
        String(item[targetField]).toLowerCase().indexOf(this.pageFilters.searchQuery.toLowerCase()) !== -1 ||
        item._id === this.pageFilters.searchQuery // Can search by uuid

      return searchKey
    })
  }

  get selectedFloor(): object {
    return {
      _id: this.selected.floor_id,
      name: this.selected.floor_name,
    }
  }

  get selectedSanID(): object {
    return {
      san_id: this.selected.san_id,
    }
  }

  get isValidLocation() {
    return !this.selected.floor_id
  }

  onTabChange(changeValue: number) {
    this.filterUtilPage.save(this.pageFilters)
    this.activeTabEdit = changeValue
  }

  handleOpenModalEdit(data): void {
    this.isFormModalActive = true
    this.selected = Object.assign({}, data)
  }

  handleOpenModalAdd(): void {
    this.isFormModalActive = true
    this.selected = new CardModel(Constant.CARD_TYPE_STATIC)
  }

  handleOpenModalImportCSV(): void {
    this.isImportCsvModalActive = true
  }

  handleCancelImportModal(): void {
    this.isImportCsvModalActive = false
    this.csvFile = null
  }

  handleOpenModelAdjustMap(isSingle: boolean = false): void {
    this.isSingleAdjustCard = isSingle
    this.isCardAdjustActive = true
  }

  async handleApplyChange(): Promise<void> {
    this.$validator.validateAll().then(result => {
      if (!result) {
        return false
      }
      if (this.$refs.beaconRef && !(this.$refs as any).beaconRef.submit()) {
        return false
      }
      if (this.isNew) {
        // add item
        this.$store.dispatch('cards/addOne', this.selected).then(resp => {
          this.isFormModalActive = false
          this.$buefy.toast.open(this.$t('messages.save_success') as string)
        })
      } else {
        // update item
        this.$store.dispatch('cards/updateOne', this.selected).then(resp => {
          this.isFormModalActive = false
          this.$buefy.toast.open(this.$t('messages.update_success') as string)
        })
      }
    })
  }

  async handleImportCSV(): Promise<void> {
    this.$store.dispatch('cards/importCSV', this.csvFile).then(resp => {
      this.handleCancelImportModal()
      this.$buefy.toast.open(this.$t('messages.save_success') as string)
    })
  }

  // methods
  convertFieldName(value: string): string | null {
    if (!value) {
      return null
    }
    return this.$t(this.filedNameLUT[value]) as string
  }

  handleCardAdjustDone(data: any = {}): void {
    if (this.isSingleAdjustCard) {
      this.selected.lat = data.lat
      this.selected.lon = data.lon
      this.selected.floor_id = data.floor_id
      this.selected.floor_name = data.floor_name
    } else {
      this.getAllCards()
    }

    this.isCardAdjustActive = false
  }

  handleSelectedFloorDone(data): void {
    this.selected.floor_id = data._id
    this.selected.floor_name = data.name
    this.isSearchFloorActive = false
  }

  selectedSanIDDone(data): void {
    this.selected.san_id = data.san_id
    this.isSearchSanIDActive = false
  }

  confirmCustomDelete(data): void {
    this.selected = data

    this.$buefy.dialog.confirm({
      title: this.$t('delete') as string,
      message: this.$t('messages.are_you_sure_want_to_delete') as string,
      confirmText: this.$t('delete') as string,
      cancelText: this.$t('button.cancel') as string,
      type: 'is-danger',
      hasIcon: true,
      onConfirm: async () => {
        // Delete row
        const index = this.cards.indexOf(this.selected)
        await this.$store.dispatch('cards/deleteOne', this.selected)
        this.selected = {}
        this.$buefy.toast.open(this.$t('messages.delete_success') as string)
      },
    })
  }

  getAllCards() {
    this.$store.dispatch('cards/getAll', {
      card_type: Constant.CARD_TYPE_STATIC,
    })
  }

  beforeDestroy() {
    this.filterUtilPage.save(this.pageFilters)
  }

  // After page created
  created() {
    this.pageFilters = this.filterUtilPage.get(this.pageFilters)
    this.csvFields = ['_id', 'san_id', 'location_name', 'floor_id', 'floor_name', 'lon', 'lat', 'card_type']
    this.getAllCards()

    if (!this.pageFilters.activeTab) {
      this.pageFilters.activeTab = 0
    }
    this.activeTabEdit = this.pageFilters.activeTab
  }
}
